/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All DXP external links.
 */
export const DXP_EXTERNAL_LINKS = {
  datastoreBlueprintMarketplace: `https://marketplace.squiz.net/blueprints`,
  datastoreCli: `https://docs.squiz.net/datastore/latest/using/datastore-cli.html`,
  datastoreCliServices: `https://docs.squiz.net/squiz-dxp/latest/dxp-cli/get-started/services.html`,
  datastoreFeaturesAndCapabilities: `https://docs.squiz.net/datastore/latest/features/index.html`,
  datastoreUserTutorials: `https://docs.squiz.net/datastore/latest/tutorials/index.html`,
};
